import * as React from "react";
import * as S from "@styled";

import { HashMap } from "shared/model/HashMap";
import { ISearchState } from "./App";
import { LoopParameter } from "./Models";

const SearchContainer: React.FC<ISearchContainerProps> = (props) => {
    const searchRef = React.useRef<HTMLInputElement>(null);
    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault(); // Prevents the page from reloading
        props.onSearch(searchRef.current?.value ?? "");
    };
    const resultLength = props.searchState?.result?.length;
    const maxResults = 100;
    const searchInputClassName = props.isSearchingEntireProcess ? "search-input-selector" : "search-input-loop-selector";

    return <>
        <S.FormGroup>
            <form onSubmit={handleSubmit}>

                <S.Label>
                    Search for value
                </S.Label>
                <S.FlexContainer gap={16}>
                    <S.FlexItem flex="1">
                        <S.Input
                            isFullWidth={true}
                            key="loopSearchInput"
                            ref={searchRef}
                            type="text"
                            defaultValue={props.searchState?.searchText || ""}
                            className={searchInputClassName}
                        />
                    </S.FlexItem>
                    <S.FlexItem flex="0">
                        <S.Button
                            title="Search"
                            style={{ padding: 15 }}
                            type="submit"
                        >
                            <S.ButtonIcon
                                className="ci-search"
                                style={{ margin: 0, fontSize: 24 }}
                            />
                        </S.Button>
                    </S.FlexItem>
                </S.FlexContainer>
            </form>
        </S.FormGroup>
        {resultLength != null &&
            <S.FormGroup>
                <S.Label>
                    {resultLength === 0 ? <span>No elements found</span> : <span>Search results</span>}
                </S.Label>

                {props.searchState!.result.slice(0, maxResults).map((result, index) => {
                    const handleSearchResultClick = () => {
                        props.onSearchResultClick(result.stepId, result.indexForStep);
                    }

                    const handleMouseOver = () => {
                        props.onMouseOver(result.stepId);
                    }

                    const selectorClassName = props.isSearchingEntireProcess ? `search-result-selector-${index}` : `search-result-selector-loop-${index}`;

                    return (
                        <div key={result.key} onMouseOver={handleMouseOver} onClick={handleSearchResultClick}>
                            <S.A style={{ cursor: "pointer" }} className={selectorClassName}>{result.displayName}</S.A>
                        </div>
                    )
                }
                )}
                {resultLength > maxResults && <div>Too many results. {resultLength - maxResults} results not shown.</div>}
            </S.FormGroup>
        }
    </>
}

interface ISearchContainerProps {
    onSearch: (searchText: string) => void;
    onSearchResultClick: (stepId: string, loopParameters: HashMap<LoopParameter>) => void;
    onMouseOver: (stepId: string) => void;
    searchState?: ISearchState;
    isSearchingEntireProcess?: boolean;
}

export default SearchContainer;